import { GetOperationQuery } from "./get-operation-query";
import { operationsService } from "../../../../front-office/services/operations";

export const GetOperationHandler = async (query: GetOperationQuery) => {
    try {
        return await operationsService.loadOperation(query.operationCode, false);
    } catch (error) {
        return null;
    }
};
